module.exports = __webpack_public_path__ + "static/media/2.a9c15641.svg";